export default __webpack_public_path__ + "static/media/KOD0103-min.e4c83879.webp";